import { getLogger } from "@goodgamestudios/logger";

const logger = getLogger("sound");

export class SoundTransform {

    public leftToLeft: number = 0;
    public leftToRight: number = 0;
    public pan: number;
    public rightToLeft: number = 0;
    public rightToRight: number = 0;
    public volume: number;

    constructor(vol: number = 1, panning: number = 0) {
        this.volume = vol;
        this.pan = panning;
    }
}
